/**
 * @generated SignedSource<<e2a60bd7875de36ec7dd74f5963addfb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternNotificationsCard_brand$data = {
  readonly androidPushNotificationCredentialsSetInAzure: boolean;
  readonly androidPushNotificationRequiresFcmv1Migration: boolean;
  readonly appConfig: {
    readonly androidPushNotificationFcmv1ClientEmail: string | null;
    readonly androidPushNotificationFcmv1PrivateKey: string | null;
    readonly androidPushNotificationFcmv1ProjectId: string | null;
    readonly azureNotificationsHubName: string;
    readonly id: string;
    readonly iosAppIdentifier: string;
    readonly iosAscTeamId: string;
    readonly iosPushNotificationServiceKey: string | null;
    readonly iosPushNotificationServiceKeyId: string | null;
  };
  readonly displayName: string;
  readonly id: string;
  readonly iosPushNotificationCertExpirationDate: any | null;
  readonly iosPushNotificationCredentialsRequireServiceKeyMigration: boolean;
  readonly iosPushNotificationCredentialsSetInAzure: boolean;
  readonly pushNotificationStats: {
    readonly androidDevices: number;
    readonly dailyMetrics: ReadonlyArray<{
      readonly date: string;
      readonly deliveries: number;
      readonly taps: number;
    }>;
    readonly iosDevices: number;
    readonly notificationsSent30d: number;
    readonly pushDeliveries30d: number;
    readonly pushTaps30d: number;
    readonly tapRate: number;
    readonly totalRegisteredDevices: number;
  };
  readonly " $fragmentType": "InternNotificationsCard_brand";
};
export type InternNotificationsCard_brand$key = {
  readonly " $data"?: InternNotificationsCard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternNotificationsCard_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternNotificationsCard_brand",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iosPushNotificationCredentialsSetInAzure",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iosPushNotificationCredentialsRequireServiceKeyMigration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iosPushNotificationCertExpirationDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "androidPushNotificationCredentialsSetInAzure",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "androidPushNotificationRequiresFcmv1Migration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandPushNotificationStats",
      "kind": "LinkedField",
      "name": "pushNotificationStats",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notificationsSent30d",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pushDeliveries30d",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pushTaps30d",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tapRate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalRegisteredDevices",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosDevices",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "androidDevices",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PushNotificationDailyMetric",
          "kind": "LinkedField",
          "name": "dailyMetrics",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deliveries",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taps",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "azureNotificationsHubName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosAscTeamId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosAppIdentifier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosPushNotificationServiceKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosPushNotificationServiceKeyId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "androidPushNotificationFcmv1PrivateKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "androidPushNotificationFcmv1ProjectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "androidPushNotificationFcmv1ClientEmail",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "712bce41736c936b039e407f74a62864";

export default node;
